
import { VehicleInfo } from "./VehicleInfo";
import { VinRecordActions } from "./VinRecordActions";

interface VinLookup {
  id: string;
  vin: string;
  vehicle_data: any;
  raw_dataone_response: any;
  created_at: string;
}

interface VinLookupRecordProps {
  lookup: VinLookup;
  onDelete?: (id: string) => void;
  onView: (lookup: VinLookup) => void;
}

export const VinLookupRecord = ({ lookup, onDelete, onView }: VinLookupRecordProps) => {
  return (
    <div className="flex items-center justify-between py-5">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <button
            onClick={() => onView(lookup)}
            className="text-sm font-medium text-everest-teal hover:text-everest-teal/80 transition-colors"
          >
            {lookup.vin}
          </button>
        </div>
        <VehicleInfo 
          data={lookup.vehicle_data} 
          dataOneData={lookup.raw_dataone_response}
        />
      </div>
      
      <VinRecordActions
        lookupId={lookup.id}
        onDelete={onDelete}
        onView={onView}
        lookup={lookup}
      />
    </div>
  );
};
